import { Form, Modal } from "antd";
import React from "react";
import { CreateWastePassportDto } from "../../../api";
import { WastePassportsColumns } from "../form/columns";

interface WastePassportFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateWastePassport: (values: CreateWastePassportDto) => void;
}

export const WastePassportForm: React.FC<WastePassportFormProps> = ({ visible, setVisible, onCreateWastePassport }) => {
  const [form] = Form.useForm<CreateWastePassportDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateWastePassport}>
        {WastePassportsColumns().map(({ title, key, rules, inputNode, hideOnForm }, index) => (
          <>
            {!hideOnForm && <Form.Item label={title} name={key} rules={rules} key={index}>
              {inputNode}
            </Form.Item>}
          </>
        ))}
      </Form>
    </Modal>
  );
};
